<input type="file" (change)="onFileSelected($event)" #fileInput hidden [accept]="accept" />
<su-button
  [disabled]="disabled"
  [skin]="skin"
  [label]="text"
  [icon]="icon"
  (onClick)="fileInput.click()"
></su-button>
